import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import QNotificationReducer from '../components/NotificationQueue/redux-objects/reducer';
import NotificationTemplates from '../components/NotificationTemplate/redux-objects/reducer';
import ApplicationReducer from '../components/Application/redux-objects/reducer';
import AuditLogReducer from '../components/AuditLogs/redux-objects/reducer';
import LoginReducer from '../components/Login/redux-objects/reducer';
import NavigationReducer from '../components/Navigation/redux-objects/reducer';
import AdministrationReducer from '../components/Administration/redux-objects/reducer';
import farsSearchDataReducer from '../components/Forms/FARS/redux-objects/reducer';
import LookupTypesReducer from '../components/LookupValues/redux-objects/reducer';
import NotificationReducer from '../components/Notifications/redux-objects/reducer';
import WorkflowReducer from '../components/Workflow/redux-objects/reducer';
import EasyQueryReducer from '../components/AdvancedSearch/redux-objects/reducer';
import RedactedReducer from '../components/RedactedFields/redux-objects/reducer';
import Vendors from '../components/ThirdPartyVendors/redux-objects/reducer';
import DataEntryQueueReducer from '../components/WorkflowQueues/DataEntry/redux-objects/reducer';
import DataTranscribeQueueReducer from '../components/WorkflowQueues/DataTranscriber/redux-objects/reducer';
import DataTranscribeReducer from '../components/Forms/DataTranscriberForm/redux-objects/reducer';
import DataTranscriberValidationQueueReducer from '../components/WorkflowQueues/DataTranscriberValidation/redux-objects/reducer';
import DriverReportReducer from '../components/WorkflowQueues/DriverReport/redux-objects/reducer';
import DriverReportFormReducer from '../components/Forms/DriverReportForm/redux-objects/reducer';
import DataTranscriberValidationReducer from '../components/Forms/DataTranscriberValidationForm/redux-objects/reducer';
import KeywordQueueReducer from '../components/WorkflowQueues/Keywords/redux-objects/reducer';
import CheckersQueueReducer from '../components/WorkflowQueues/Checkers/redux-objects/reducer';
import QueueReducer from '../components/WorkflowQueues/redux-objects/reducer';
import KeywordFormReducer from '../components/WorkflowQueues/Keywords/redux-objects/KeywordFormReducer';
import MatchingQueueReducer from '../components/WorkflowQueues/Matching/redux-objects/reducer';
import DmvSearchReducer from '../components/DmvSearch/redux-objects/reducer';
import WorkZoneSearch from '../components/WorkZoneSearch/redux-objects/reducer';
import FlashlightSearchReducer from '../components/FlashlightSearch/redux-objects/reducer';
import DuplicateSearchReducer from '../components/DuplicateSearch/redux-objects/reducer';
import ExtractsReducer from '../components/Extracts/redux-objects/reducer';
import PbiReducer from '../components/PowerBI/redux-objects/reducer';
import DashboardReducer from '../components/Dashboard/redux-objects/reducer';
import DataEntryReducer from '../components/Forms/DataEntryForm/redux-objects/reducer';
import CommentsReducer from '../components/Comments/redux-objects/reducer';
import CorrespondenceReducer from '../components/Correspondence/redux-objects/reducer';
import ViewTvalReducer from '../components/shared/ViewTvalFormButton/redux-objects/reducer';
import DocumentViewerReducer from '../components/DocumentViewer/redux-objects/reducer';
import ManagementReducer from '../components/WorkflowQueues/Management/redux-objects/reducer';
import StandardSummaryReducer from '../components/StandardSummary/redux-objects/reducer';
import HealthDashboardReducer from '../components/HealthDashboard/redux-objects/reducer';
import CaseStudySearchReducer from '../components/CaseStudySearch/redux-objects/reducer';
import ReportChainReducer from '../components/Administration/ReportChainEditor/redux-objects/reducer';

const rootReducer = combineReducers({
  Admin: AdministrationReducer,
  Application: ApplicationReducer,
  auditLogs: AuditLogReducer,
  EasyQuery: EasyQueryReducer,
  farsSearchData: farsSearchDataReducer,
  Login: LoginReducer,
  LookupTypes: LookupTypesReducer,
  Keywords: KeywordQueueReducer,
  Navigation: NavigationReducer,
  Notifications: NotificationReducer,
  NotificationTemplates,
  qnotification: QNotificationReducer,
  RedactedFields: RedactedReducer,
  Routing: routerReducer,
  Vendors: Vendors,
  DataTranscribeQueue: DataTranscribeQueueReducer,
  DataTranscriberValidationQueue: DataTranscriberValidationQueueReducer,
  DriverReport: DriverReportReducer,
  DriverReportForm: DriverReportFormReducer,
  KeywordForm: KeywordFormReducer,
  CheckersQueue: CheckersQueueReducer,
  DataEntryQueue: DataEntryQueueReducer,
  DataTranscriber: DataTranscribeReducer,
  DataTranscriberValidation: DataTranscriberValidationReducer,
  Workflow: WorkflowReducer,
  WorkflowQueues: QueueReducer,
  DmvSearch: DmvSearchReducer,
  FlashlightSearch: FlashlightSearchReducer,
  MatchingQueue: MatchingQueueReducer,
  DuplicateSearch: DuplicateSearchReducer,
  Extracts: ExtractsReducer,
  PowerBI: PbiReducer,
  Dashboard: DashboardReducer,
  DataEntry: DataEntryReducer,
  Comments: CommentsReducer,
  Correspondence: CorrespondenceReducer,
  WorkZoneSearch: WorkZoneSearch,
  ViewTval: ViewTvalReducer,
  DocumentViewer: DocumentViewerReducer,
  Management: ManagementReducer,
  StandardSummary: StandardSummaryReducer,
  HealthDashboard: HealthDashboardReducer,
  CaseStudy: CaseStudySearchReducer,
  ReportChain: ReportChainReducer
});

export default rootReducer;
